export const Flows = {
    CONTACT_US: 'contact-us',
    CLOSE_ACCOUNT: 'close-account',
    RIPPED_MUSIC_OFFLINE: 'ripped-music-offline',
};
//# sourceMappingURL=Flow.js.map